import script from "./detailsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./detailsIndex.vue?vue&type=script&setup=true&lang=js"

import "./detailsIndex.vue?vue&type=style&index=0&id=4e75fa8f&lang=less"

const __exports__ = script;

export default __exports__